module.exports = __webpack_public_path__ + "img/content_image5.8d3f22ce.png";